module.exports = __webpack_public_path__ + "img/w3_maximize_black.7f646fc3.png";